import { NgModule, provideAppInitializer, inject } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations'
import { FormsModule } from '@angular/forms';
import { HTTP_INTERCEPTORS, provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { FooterComponent } from './shared/components/layouts/footer/footer.component';
import { NavbarOneComponent } from './shared/components/layouts/navbar-one/navbar-one.component';
import { PreloaderComponent } from './shared/components/layouts/preloader/preloader.component';
import { ToastrModule } from 'ngx-toastr';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { AngularMaterialModule } from './angular-material.module';
import { ApiInterceptor } from './shared/interceptors/api.interceptors';
import {
    MSAL_INSTANCE,
    MSAL_GUARD_CONFIG,
    MSAL_INTERCEPTOR_CONFIG,
    MsalService,
    MsalGuard,
    MsalBroadcastService
} from '@azure/msal-angular';
import {
    MSALInstanceFactory,
    MSALGuardConfigFactory,
    MSALInterceptorConfigFactory
} from './shared/auth/msal.config';
import { initializeSso } from './shared/auth/sso-initializer';
import { AuthService } from './shared/services';
import { AssistantChatComponent } from './shared/components/assistant-chat/assistant-chat.component';
import { GlobalSearchComponent } from './shared/components/global-search/global-search.component';
import { NotificationBellComponent } from './shared/components/notification-bell/notification-bell.component';
import { ServiceAnnouncementComponent } from './shared/components/service-announcement/service-announcement.component';

@NgModule({ declarations: [
        AppComponent,
        FooterComponent,
        NavbarOneComponent,
        PreloaderComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserAnimationsModule,
        BrowserModule,
        AppRoutingModule,
        FormsModule,
        AngularMaterialModule,
        ToastrModule.forRoot({
            closeButton: true,
            preventDuplicates: true,
            timeOut: 5000
        }),
        NgbModule,
        // Standalone components used by the app shell
        AssistantChatComponent,
        GlobalSearchComponent,
        NotificationBellComponent,
        ServiceAnnouncementComponent], providers: [
        {
            provide: HTTP_INTERCEPTORS,
            useClass: ApiInterceptor,
            multi: true
        },
        provideHttpClient(withInterceptorsFromDi()),
        // MSAL providers - inert while environment.sso.enabled is false (placeholder clientId,
        // nothing invokes MsalService). Wired now so SSO activation is a fast-follow, not a re-architecture.
        { provide: MSAL_INSTANCE, useFactory: MSALInstanceFactory },
        { provide: MSAL_GUARD_CONFIG, useFactory: MSALGuardConfigFactory },
        { provide: MSAL_INTERCEPTOR_CONFIG, useFactory: MSALInterceptorConfigFactory },
        MsalService,
        MsalGuard,
        MsalBroadcastService,
        // SSO bootstrap: initialize MSAL, process any redirect, and load /user/me before the app
        // renders. No-op in JWT mode (initializeSso returns immediately when sso.enabled is false).
        provideAppInitializer(() => initializeSso(inject(MsalService), inject(AuthService)))
    ] })
export class AppModule { }
